<template>
  <AuthWrapper>
    <router-view />
  </AuthWrapper>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { MAX_PASSWORD_LENGTH } from "@/const";
import AuthWrapper from "./AuthWrapper"
import logout from "@/logout"
export default {
  components: {
    AuthWrapper,
  },
  computed: {
    ...mapGetters("auth/login", [
      "getInProgress",
      "getSuccess",
      "getErrorMessages",
    ]),
    userId() {
      return this.$root.userId;
    },
    errors() {
      let errorText = "";
      if (this.getErrorMessages.length == 0) {
        return false;
      } else {
        for (const error of this.getErrorMessages) {
          errorText += error;
        }
      }
      return errorText;
    },
  },
  created() {
    this.MAX_PASSWORD_LENGTH = MAX_PASSWORD_LENGTH;
  },
  methods: {
    ...mapMutations("auth", ["setMe"]),
    loginAction() {
      this.logIn({ username: this.username, password: this.password });
    },
    ...mapActions("auth/login", ["logIn"]),
    logout() {
      logout()
    },
  },
  watch: {
    getSuccess(newValue) {
      if (newValue == true) {
        this.username = "";
        this.password = "";
      }
    },
  },
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      rules: {
        required: (value) => !!value || this.$t("forms.thisFieldIsRequired"),
      },
    };
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-text-field fieldset {
  border: 2px solid;
  border-radius: 16px;
}
::v-deep h1 {
  font-size: 1.3em;
  text-align: left;
}
</style>
